import * as actionTypes from '../constants/actionTypes';
import * as pricingPresetPages from '../constants/pricingPresets';
import { camelizeKeys } from 'humps';
import * as _ from "lodash";
import { getApiConfig } from '../utilities/backend';
import * as actions from '../actions';
import {
  getFilteredEnabledUpdatedStones
} from '../selectors';
import { asFabricatorId } from "../reducers/asCustomer";
import { findGaps } from '../components/StoneSetup/AssignPricing/PricingPresets/editPreset';
import * as PricingPresetDataTypes from '../constants/pricingPresets';
import customEvent from "../utilities/customEvent";

const { get, post } = getApiConfig();

export function loadPresets(withLoader = true) {
  return function (dispatch, getState) {
    let state = getState();
    const { asCustomer, auth } = state;
    if (withLoader) {
      dispatch(actions.loadingDialog_show(true, 'Loading Pricing Profiles', 'Please wait while we look up your latest pricing data.'));
    }
    dispatch({
      type: actionTypes.PRICING_PRESET_SET_PRESETS_RECEIVED,
      payload: { presetsReceived: false }
    });
    return new Promise((resolve, reject) => {
      get('Api/Dashboard/GetPricingPresets?fabricatorId=' + (asFabricatorId(asCustomer) || auth.fabricatorId))
        .then(json => camelizeKeys(json))
        .then((result) => {
          document.dispatchEvent(customEvent("transientUpdatesCleared"));
          return new Promise((resolve) => {
            console.log("response get presets ->", result);
            dispatch({
              type: actionTypes.PRICING_PRESET_SET_PRESETS,
              payload: { presets: result }
            });
            resolve(result);
          });
        }).then(() => {
          if (withLoader) {
            dispatch(actions.loadingDialog_show(false));
          }
          resolve();
        }).catch((e) => {
          if (withLoader) {
            dispatch(actions.loadingDialog_show(false));
          }
          reject(e);
        });
    });
  }
}

export function show(show) {
  if (typeof show !== 'boolean') {
    show = false;
  }
  return function (dispatch) {
    return new Promise((resolve) => {
      if (show) {
        dispatch(loadPresets())
          .then(() => dispatch({
            type: actionTypes.PRICING_PRESET_SHOW,
            payload: {
              show
            }
          }))
          .then(() => dispatch(changePage(pricingPresetPages.PRICING_PRESET_LIST)))
          .then(resolve);
      } else {
        dispatch({
          type: actionTypes.PRICING_PRESET_SHOW,
          payload: {
            show
          }
        });
        resolve();
      }
    });
  }
}

export function showEdit(selectedPreset) {
  return function (dispatch) {
    dispatch(loadPresets())
      .then(() => dispatch(setSelected(selectedPreset)))
      .then(() => dispatch(changePage(pricingPresetPages.PRICING_PRESET_EDIT)));
  }
}

export function save() {
  return function (dispatch, getState) {
    return new Promise((resolve, reject) => {
      let state = getState(),
        errs = [],
        preset = state.pricingPreset.selectedPreset;

      if (!preset.name || preset.name === '' || preset.name === null) {
        errs.push("Please enter an algorithm Name");
      }
      if (!preset.icon || preset.icon === '' || preset.icon === null) {
        errs.push("Please select an algorithm Icon");
      }

      if (preset.data && preset.data.length > 0) {
        let gaps = findGaps(preset.data);
        if (gaps.foundGap) {
          for (let index in gaps.gaps) {
            let gap = gaps.gaps[index];
            errs.push("Gap found in pricing logic between quantities: " + gap.from + " and " + gap.to);
          }
        }
      }

      if (errs.length === 0) {
        let data = {
          Id: preset.id,
          Type: preset.type || 'stone',
          Fabricator_Id: preset.fabricatorId,
          Name: preset.name,
          Icon: preset.icon,
          IsDefault: preset.isDefault,
          PricingPresetData: JSON.stringify(preset.data),
          PricingPresetCostData: !preset.costData ? null : JSON.stringify(preset.costData),
          PricingPresetDiscountData: !preset.discountData ? null : JSON.stringify(preset.discountData),
        };
        let allPriced = true;
        for (let index in preset.data) {
          let dat = preset.data[index];
          if (!(+dat.value) && (index > 0 || dat.type == PricingPresetDataTypes.PRICING_PRESET_SLAB_SEG)) {
            // added +dat.value to convert "0" to 0, because !"0" is false and !0 is true
            allPriced = false;
          }
        }
        post(data, 'Api/Dashboard/SavePricingPreset')
          .then(json => camelizeKeys(json))
          .then(response => dispatch(setSelected(response)))
          .then(() => {
            if (state.pricingPreset.page == pricingPresetPages.PRICING_PRESET_EDIT) {
              if (!allPriced) {
                dispatch(actions.messageBox_Show(true, "system", "Not all segments have a price", "Some pricing segments are not priced or priced at $0.", [
                  {
                    text: 'Keep Editing',
                    subtext: 'Save and continue editing this pricing preset',
                    onClick: () => dispatch(actions.messageBox_Show()) //reset to default props (not visible by default)
                  }, {
                    text: 'Continue',
                    subtext: 'Save and close the pricing preset window',
                    onClick: () => {
                      dispatch(actions.messageBox_Show());
                      return dispatch(show(false));
                    } //reset to default props (not visible by default)
                  }
                ]));
              } else {
                return dispatch(show(false));
              }
            }
          })
          .then(() => dispatch(loadPresets()))
          .then(resolve)
          .catch(reject);
      } else {
        dispatch(actions.messageBox_Show(true, "error", "Unable to Save", errs.join("<br>")));
        reject(errs.join('\r\n'));
      }
    });
  }
}

export function deletePreset() {
  return function (dispatch, getState) {
    return new Promise((resolve, reject) => {
      const state = getState();
      if (state.pricingPreset.selectedPreset.id > 0) {
        let preset = state.pricingPreset.selectedPreset;
        let data = {
          pricingPresetId: preset.id
        };
        post(data, 'API/Dashboard/DeletePricingPreset')
          .then(() => dispatch({
            type: actionTypes.PRICING_PRESET_DELETE,
            payload: { ...data }
          }))
          .then(resolve)
          .catch(reject);
      }
    }).catch(console.error);
  }
}

export function setSelected(selectedPreset) {
  return function (dispatch, getState) {
    return new Promise((resolve, reject) => {
      const { auth, asCustomer } = getState();
      dispatch({
        type: actionTypes.PRICING_PRESET_SET_SELECTED,
        payload: { selectedPreset }
      });
      dispatch(updateValue('fabricatorId', asFabricatorId(asCustomer) || auth.fabricatorId));
      resolve(selectedPreset);
    }).catch(console.error);
  }
}

export function changePage(page) {
  return function (dispatch) {
    return new Promise((resolve, reject) => {
      dispatch({
        type: actionTypes.PRICING_PRESET_SHOW,
        payload: { page, show: true }
      });
      resolve();
    }).catch(console.error);
  }
}

export function updateValue(field, value) {
  return function (dispatch) {
    dispatch({
      type: actionTypes.PRICING_PRESET_UPDATE_VALUE,
      payload: {
        field,
        value
      }
    });
  };
}

export function selectStone(stone) {
  return function (dispatch) {
    dispatch({
      type: actionTypes.PRICING_PRESET_SELECT_STONE,
      payload: {
        key: stone.id,
        value: stone
      }
    })
  }
}

export function selectAllStones() {
  return function (dispatch, getState) {
    var state = getState();
    var stones = getFilteredEnabledUpdatedStones(state);
    var selectedStones = {};
    stones.forEach(function (stone) {
      selectedStones[stone.id] = stone;
    }, this);

    dispatch({
      type: actionTypes.PRICING_PRESET_SET_SELECTED_STONES,
      payload: {
        selected: selectedStones
      }
    });
  }
}

export function deselectAllStones() {
  return function (dispatch) {
    dispatch({
      type: actionTypes.PRICING_PRESET_SET_SELECTED_STONES,
      payload: {
        selected: {}
      }
    });
  }
}

function isEmpty(map) {
  for (var key in map) {
    return !map.hasOwnProperty(key);
  }
  return true;
}

export function showAssignPricing(show) {
  return function (dispatch, getState) {
    return new Promise((resolve) => {
      const state = getState();
      if (isEmpty(state.pricingPreset.selected) && show) {
        dispatch(actions.messageBox_Show(true, "system", "No Stones Selected", "Please select stones to assign a pricing profile.  Select stones by clicking to put a check in the circle on each stone."));
        resolve();
      } else {
        if (typeof show !== 'boolean') {
          show = false;
        }
        if (show) {
          dispatch(loadPresets())
            .then(() => {
              return new Promise((_resolve) => {
                dispatch({
                  type: actionTypes.PRICING_PRESET_ASSIGN_SHOW,
                  payload: {
                    show
                  }
                });
                resolve(_resolve);
              });
            })
            .then(resolve);
        } else {
          dispatch({
            type: actionTypes.PRICING_PRESET_ASSIGN_SHOW,
            payload: {
              show
            }
          });
          resolve();
        }
      }
    }).catch(console.error);
  }
}

export function assignPricingPresets(unassign) {
  return function (dispatch, getState) {

    const state = getState();
    const { asCustomer, auth } = state;
    if (state.pricingPreset.selectedPreset.id > 0 || state.pricingPreset.selectedPreset.id == null) {
      if (state.pricingPreset.selectedPreset.id > 0 && !state.pricingPreset.selectedPreset.data) {
        dispatch(actions.messageBox_Show(true, "system", "No Pricing Algorithm Data", "Can't assign empty pricing algorithm to the selected stones."));
        return
      }
      dispatch(actions.loadingDialog_show(true, "Assigning Pricing Profile", "Assigning Pricing Profile, please wait..."));
      let preset = state.pricingPreset.selectedPreset;
      var stoneIds = _.flatMap(state.pricingPreset.selected, (s) => s.id);

      let data = {
        fabricator_id: (asFabricatorId(asCustomer) || auth.fabricatorId),
        preset_id: preset.id,
        stone_ids: state.pricingPreset.selectedPreset.id == null ? [] : stoneIds,
        unassign_ids: state.pricingPreset.selectedPreset.id == null ? stoneIds : _.flatMap(unassign, u => u.id)
      };
      post(data, 'Api/Dashboard/AssignStonePricing')
        .then(json => camelizeKeys(json))
        .then(() => dispatch(actions.updateStoneSupplierStoneStoreValue(data.stone_ids, 'pricingPreset_id', data.preset_id)))
        .then(() => dispatch(actions.updateStoneSupplierStoneStoreValue(data.unassign_ids, 'pricingPreset_id', null)))
        .then(() => dispatch(actions.pricingPresets.loadPresets()))
        .then(() => {
          dispatch(actions.pricingPresets.showAssignPricing(false));
          dispatch(actions.loadingDialog_show(false));
        })
        .catch(() => {
          dispatch(actions.pricingPresets.showAssignPricing(false));
          dispatch(actions.loadingDialog_show(false));
        });
    } else {
      dispatch(actions.messageBox_Show(true, "system", "No Pricing Algorithm selected", "Please select a pricing algorithm to assign to the selected stones."));
    }
  }
}

export function clonePricingPresetsInto(targetFabricatorIds) {
  return (dispatch, getState) => {
    return new Promise(resolve => {
      const { post } = getApiConfig();

      const { auth, asCustomer } = getState();
      const fabId = asCustomer.data ? asCustomer.data.fabricatorId : auth.fabricatorId;

      post(targetFabricatorIds, `Api/Dashboard/ClonePricingPresetsToFabricator?fabricatorId=${fabId}`)
      .then(resolve);
    }).catch(console.error);
  }
}

export function setPricingPresetApplyToPrice(applyToPrice) {
  return (dispatch) => {
    dispatch({
      type: actionTypes.PRICING_PRESET_SET_APPLY_TO_PRICE,
      payload: {applyToPrice}
    })
  }
}
